import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    get_coactivity,
  add_coactivity,
  update_coactivity,
  delete_coactivity,
  get_coactivity_list
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
    coactivity: [],
    coactivitylist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    category:""
  },
};
// Async Thunks for API Calls
export const fetchcoactivitylist = createAsyncThunk(
    'coactivity/fetchcoactivitylist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_coactivity_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  
// Async Thunks for API Calls
export const fetchcoactivity = createAsyncThunk(
  "coactivity/fetchcoactivity",
  async ({ page, page_size,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_coactivity(page, page_size,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createcoactivity = createAsyncThunk(
  "coactivity/createcoactivity",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_coactivity(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatecoactivity = createAsyncThunk(
  "coactivity/updatecoactivity",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_coactivity(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletecoactivity = createAsyncThunk(
  "coactivity/deletecoactivity",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_coactivity({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// hostel_category Slice
const coactivitySlice = createSlice({
  name: 'coactivitys',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, name,category } = action.payload;
      state.formData = { id, name,category };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        category:""
      };
    },
    setcoactivity(state, action) {
      state.coactivity = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchcoactivitylist.fulfilled, (state, action) => {
           state.coactivitylist = action.payload;
         })
         .addCase(fetchcoactivitylist.rejected, (state, action) => {
           state.coactivitylist = [];
   
         })
       // Fetch hostel_category
       .addCase(fetchcoactivity.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchcoactivity.fulfilled, (state, action) => {
        state.loading = false;
        state.coactivity = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchcoactivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add hostel_category
      .addCase(createcoactivity.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createcoactivity.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createcoactivity.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update hostel_category
      .addCase(updatecoactivity.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatecoactivity.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatecoactivity.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete hostel_category
      .addCase(deletecoactivity.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletecoactivity.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletecoactivity.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setcoactivity,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = coactivitySlice.actions;
export default coactivitySlice.reducer;
